<section class="mx-3">
  <mat-dialog-content class="mat-typography">
    <div class="d-flex justify-content-between">
      <div>
        <h2 translate mat-dialog-title>Add Holiday</h2>
      </div>
      <div class="cursor_pointer" (click)="Canceldailog()">
        <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="close"></mat-icon>
      </div>
    </div>
    <mat-divider></mat-divider>
    <div class="p-3">
      <div class="position-relative pt-2">
        <div class="form">
          <div class="container">
            <form (ngSubmit)="onSubmit()" [formGroup]="holidayForm">
              <div class="row">
                <div *ngFor="let question of questions" class="mb-3 col-sm-6">
                  <app-question [question]="question" [form]="holidayForm"></app-question>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <div class="form-row">
      <button translate mat-stroked-button (click)="Canceldailog()" class="px-5 cancel_button">Cancel</button>
      <button translate mat-raised-button color="primary" (click)="onSubmit()" class="px-5 submit_button" type="submit" [disabled]="!holidayForm.valid">Save</button>
    </div>
  </mat-dialog-actions>
</section>